<div class="modal-content-datalhes">
  <div id="carouselExample" class="carousel slide" data-bs-ride="false">
    <!-- Indicadores -->
    <div class="carousel-indicators">
      <button *ngFor="let group of groupedFotos; let i = index" [attr.data-bs-target]="'#carouselExample'"
        [attr.data-bs-slide-to]="i" [class.active]="i === 0"></button>
    </div>
    <!-- Slides -->
    <div class="carousel-inner">
      <div *ngFor="let group of groupedFotos; let i = index" class="carousel-item" [class.active]="i === 0">
        <div class="row d-flex flex-nowrap" style="
            --bs-gutter-x: 5px;
            overflow-x: auto;
            scroll-snap-type: x mandatory;
          ">
          <div [class.col-12]="mobile" [class.col-4]="!mobile" *ngFor="let foto of group;" class="flex-shrink-0">
            <div class="image-container">
              <div class="selo">
              </div>
              <img [src]="foto.link" class="d-block w-100" alt="Imagem {{ i + 1 }}"
                style="height: 78vh; background: #cdcdcd; object-fit: cover" (click)="abrirGaleria(foto.index)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Controles de navegação -->
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>

  <div class="detalhes-imovel-container">
    <!-- Parte Principal -->
    <div class="conteudo-principal">
      <!-- Linha dos botões -->
       <div style="width: 100%; display: flex; justify-content: space-between;">

         <div class="botoes" style="max-height: 35px;">
           <button *ngIf=" (imovel2?.videos??[]).length > 0 " class="botao" style="border: 1.5px solid #535353"
            (click)="abreApresentacao()">
            Ver Vídeo
          </button>
          <!-- <button class="botao" style="border: 1.5px solid #535353;">Tour Virtual</button> -->
          <button class="botao" style="color: #d71614 !important" id="fullscreen-map-btn-desktop"
          (click)="clickVerMapa()">
          Ver Mapa
        </button>
        
      </div>
        <img *ngIf="hasFeirao(imovel2)" width="150px" src="../../../assets/selo_roleta_small.png" alt="Selo" />

    </div>

      <!-- <div class="botoes">
        <button class="botao mobile" style="color: #d71614 !important" id="fullscreen-map-btn-mobile"
          (click)="clickVerMapa()">
          Ver Mapa
        </button>

      </div> -->
      
      <app-tags [tags]="imovel2?.tags"></app-tags>

      <!-- Linha com endereço e valor -->
      <div class="info-principal">
        <div class="title-responsive">
          <h2 class="titulo" style="text-transform: capitalize;">{{ imovel2?.titulo }} <span
              style="font-size: 12px;">Código: {{imovel2?.codigo}}</span>
          </h2>
          <p class="endereco">
            <i class="fa-sharp fa-solid fa-location-dot" style="color: #000000"></i>
            {{ imovel2?.endereco_logradouro ? imovel2.endereco_logradouro + ',' : '' }} {{ imovel2?.endereco_bairro }} -
            {{ imovel2?.endereco_cidade }},
            {{ imovel2?.endereco_estado }}

          </p>
          <p *ngIf="imovel2?.condominio_nome">
            <i class="fa-sharp fa-solid fa-building" style="color: #000000"></i>
            <span class="button" (click)="abreCondominio(imovel2.id_condominio)" class="condominio-button">
              Condomínio: {{imovel2?.condominio_nome}}</span>
          </p>

        </div>
        <div style="margin-top: 10px;">
          <div>
           <span *ngIf="hasFeirao(imovel2) && (imovel2?.valor_locacao_anterior ?? imovel2?.valor_venda_anterior ?? 0 ) > 0" class="valor-anterior">De:  <s>{{ (imovel2?.valor_locacao_anterior ??
                      imovel2?.valor_venda_anterior ) | currency: 'BRL' }}<span
                        *ngIf="imovel2?.valor_locacao_anterior">/mês</span></s></span>

            <span *ngIf="(imovel2?.valor_venda_visivel && imovel2?.valor_venda > 0); else verificarLocacao">
              <p class="valor">
                <!-- {{ imovel2?.contrato }} por <br /> -->
                R$ <span class="valor-numeral"> {{ imovel2?.valor_venda | number : '1.2-2':'pt-BR' }} </span>
              </p>
            </span>
            <ng-template #verificarLocacao>
              <span *ngIf="(imovel2?.valor_locacao_visivel && imovel2?.valor_locacao > 0); else semValor">
                <p class="valor">
                  <!-- {{ imovel2?.contrato }} por <br /> -->
                  R$ <span class="valor-numeral">{{ imovel2?.valor_locacao | number : '1.2-2':'pt-BR' }}/mês </span>
                </p>
              </span>
            </ng-template>
            <ng-template #semValor>
              <p class="valor">Valor sob consulta!</p>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Frame do mapa -->
      <div class="mapa" #mapaSecao *ngIf="verMapa">
        <!-- Botão de fechar visível somente no modo tela cheia -->
        <div id="map" style="width: 100%; height: 250px"></div>
      </div>

      <!-- <div style="display: flex; justify-content: space-between; align-items: end">

        <div class="info-item">
          <p>
            <span class="label">Código</span><br /><strong>{{
              imovel2?.codigo
              }}</strong>
          </p>
        </div>
      </div> -->

      <!-- Descrição -->
      <p class="descricao">
        {{ imovel2?.observacoes }}
      </p>
      <div class="infos-icons" style="margin-top: 10px;">
        <div class="info-icons-item"
          *ngIf="temAreaPrivativa(imovel2) && imovel2?.subtipo | deveExibirAtributo: 'area_privativa'">
          <p style="display: flex; flex-direction: column; align-items: center;">
            <i class="fa-solid fa-ruler-combined" style="margin: 0px 5px"></i>
            <strong>{{ imovel2?.area_privativa | number:'1.0-0' }} m²</strong>
            <span class="label">Área</span>
          </p>
        </div>
        <div class="info-icons-item" *ngIf="imovel2?.subtipo | deveExibirAtributo: 'terreno_total'">
          <p style="display: flex; flex-direction: column; align-items: center;">
            <mat-icon>border_outer</mat-icon>
            <strong>{{ (imovel2?.terreno_total ?? imovel2?.area_privativa) | number:'1.0-0' }} m²</strong><br />
            <span class="label">Área</span>
          </p>
        </div>
        <div class="info-icons-item"
          *ngIf="imovel2?.dormitorios && imovel2?.subtipo | deveExibirAtributo: 'dormitorios'">
          <p style="display: flex; flex-direction: column; align-items: center;">
            <i class="fa-solid fa-bed"></i>
            <strong>{{ imovel2?.dormitorios }}</strong>
            <span class="label">Dormitórios <br />
              <ng-container *ngIf="imovel2 && temSuites(imovel2)">
                ({{ imovel2.suites }}
                {{ imovel2.suites === 1 ? "Suíte" : "Suítes" }})
              </ng-container>
            </span>
          </p>
        </div>

        <div class="info-icons-item" *ngIf="imovel2?.subtipo | deveExibirAtributo: 'banheiros'">
          <p style="display: flex; flex-direction: column; align-items: center;">
            <i class="fa-solid fa-shower"></i>
            <strong>{{ imovel2?.banheiros ?? 0 }}</strong>
            <span class="label">
              {{ imovel2?.banheiros === 1 ? "Banheiro" : "Banheiros" }}</span>
          </p>
        </div>

        <div class="info-icons-item" *ngIf="imovel2?.subtipo | deveExibirAtributo: 'garagens'">
          <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <i class="fa-solid fa-car"></i>
            <strong>{{ imovel2?.garagens ?? 0 }}</strong>
            <span class="label">{{
              (imovel2?.garagens ?? 0) > 1 ? "Vagas" : "Vaga"
              }}</span>
          </p>
        </div>
        <div class="info-icons-item" *ngIf="imovel2?.mobilia > 0">
          <p>
            <i class="fa-solid fa-chair"></i>
            <br />
            <span class="label">
              {{ imovel2?.mobilia === 1 ? 'Mobiliado' : 'Semimobiliado' }}
            </span>
          </p>
        </div>

        <div class="info-icons-item"
          *ngIf="imovel2?.terreno_fundos && imovel2?.subtipo | deveExibirAtributo: 'terreno_fundos'">
          <p>
            <strong>{{ imovel2?.terreno_fundos | number:'1.0-0' }} {{ imovel2?.medida }} </strong>
            <mat-icon style="margin-left: 2px;">border_top </mat-icon>
            <br />
            <span class="label">Fundos </span>
          </p>
        </div>

        <div class="info-icons-item"
          *ngIf="imovel2?.terreno_frente && imovel2?.subtipo | deveExibirAtributo: 'terreno_frente'">
          <p>
            <strong>{{ imovel2?.terreno_frente | number:'1.0-0' }} {{ imovel2?.medida }} </strong>
            <mat-icon style="margin-left: 2px;">border_bottom </mat-icon>
            <br />
            <span class="label">Frente </span>
          </p>
        </div>

        <div class="info-icons-item"
          *ngIf="imovel2?.terreno_esquerda && imovel2?.subtipo | deveExibirAtributo: 'terreno_esquerda' ">
          <p>
            <strong>{{ imovel2?.terreno_esquerda | number:'1.0-0' }} {{ imovel2?.medida }} </strong>
            <mat-icon style="margin-left: 2px;">border_left </mat-icon>
            <br />
            <span class="label">Esquerda </span>
          </p>
        </div>

        <div class="info-icons-item"
          *ngIf="imovel2?.terreno_direita && imovel2?.subtipo | deveExibirAtributo: 'terreno_direita'">
          <p>
            <strong>{{ imovel2?.terreno_direita | number:'1.0-0' }} {{ imovel2?.medida }} </strong>
            <mat-icon style="margin-left: 2px;">border_right </mat-icon>
            <br />
            <span class="label">Direita </span>
          </p>
        </div>
      </div>
      <!-- <div class="grid-table">
        <div class="row">
          <div style="justify-content: space-between !important">
            <strong>Subtipo</strong> {{ imovel2?.subtipo }}
          </div>
          <!-- <div style="justify-content: space-between!important;"><strong>Situação</strong> {{ imovel?.situacao }}</div> 
        </div>
        <div class="row">
          <div style="justify-content: space-between !important" *ngIf="imovel2?.area_total ?? 0 > 1">
            <strong>Área total</strong> {{ imovel2?.area_total }} m²
          </div>
          <div *ngIf="imovel2?.area_privativa ?? 0 > 1" style="justify-content: space-between !important">
            <strong>Área privativa</strong> {{ imovel2?.area_privativa }} m²
          </div>
        </div>
      </div> -->


      <app-comodidades [comodidades]="this.imovel2?.imovel_comodidades"></app-comodidades>

    </div>

    <!-- Parte Lateral Flutuante -->
    <div class="conteudo-lateral">
      <div class="box">
        <!-- <div class="cabecalho-lateral">
          <h3>Investimento</h3>
          <p>R$ -</p>
        </div> -->
        <div class="cabecalho-lateral">
          <p>Condomínio *</p>
          <p>
            {{
            imovel2?.valor_condominio_visivel
            ? (imovel2?.valor_condominio | currency : "BRL")
            : "Sob Consulta"
            }}
          </p>
        </div>
        <div class="cabecalho-lateral">
          <p>IPTU *</p>
          <p>
            {{
            imovel2?.valor_iptu_visivel
            ? (imovel2?.valor_iptu | currency : "BRL")
            : "Sob Consulta"
            }}
          </p>
        </div>
        <div *ngIf=" imovel2?.contrato === 'Compra' " class="cabecalho-lateral">
          <p>Impostos e Transferência *
          </p>
          <p> {{ imovel2?.valor_venda ? ((imovel2?.valor_venda * 0.03) | currency: 'BRL') : 'Sob Consulta'}}

          </p>
        </div>
        <div class="cabecalho-lateral">
          <p style="font-size: small;">* Valores aproximados</p>
        </div>
        <div class="cabecalho-chamada-texto">
          <!-- <h3>Tem interesse neste imóvel?</h3> -->
          <div style="width: 100%; display: flex; justify-content: center; ">
            <button class="btn btn-success" style="display: flex; margin:15px; align-items: center; gap: 8px;"
              type="button" (click)="openWhatsApp()">
              <i class="fab fa-whatsapp"></i>
              Fale com um consultor
            </button>
          </div>
          <div style="display: flex; align-items: center; text-align: center;">
            <hr style="flex: 1; border: none; height: 1px; background-color: #ccc;">
            <span style="padding: 0 10px; color: #272727 ">ou</span>
            <hr style="flex: 1; border: none; height: 1px; background-color: #ccc;">
          </div>
          <p>
            <button class="btn btn-primary" (click)="mostrarFormulario = !mostrarFormulario" *ngIf="!mostrarFormulario">
              <i class="fa-solid fa-pencil" style="margin-right: 10px;"></i>
              Preencha seus dados clicando aqui
            </button>

          </p>
        </div>

        <div class="area-caracteristicas" *ngIf="mostrarFormulario"></div>


        <form [formGroup]="leadForm" (ngSubmit)="enviarLead()" *ngIf="mostrarFormulario">
          <div class="form-container">
            <!-- Nome -->
            <div class="form-group">
              <label for="nome">Nome</label>
              <input type="text" id="nome" formControlName="nome" placeholder="Coloque seu nome aqui" />
            </div>

            <!-- E-mail -->
            <div class="form-group">
              <label for="email">E-mail</label>
              <input type="email" id="email" formControlName="email" placeholder="Coloque seu melhor e-mail" />
            </div>

            <!-- Telefone -->
            <div class="form-group">
              <label for="telefone">Telefone</label>
              <input type="tel" id="telefone" formControlName="telefone" placeholder="Coloque seu número de WhatsApp"
                mask="(00) 00000-0000" />
            </div>

            <div style="display: flex; gap: 10px">
              <!-- Botão para enviar o formulário -->
              <button class="btn btn-primary" type="submit">
                Contatar Corretor
              </button>
            </div>
          </div>
        </form>
      </div>
      <div style="padding: 15px"></div>
      <!-- Parte Lateral Flutuante -->
      <div class="box" *ngIf="!!captador">
        <div class="cabecalho-lateral" (click)="acessaCorretor(captador.codigo)">
          <div style="display: flex; width: 30%; justify-content: end">
            <div class="corretor">
              <img [src]="captador.avatar" />
            </div>
          </div>

          <div class="cabecalho-corretor-texto" (click)="acessaCorretor(captador.codigo)">
            <h3>{{ captador.nome }}</h3>
            <p>Corretor de imóveis</p>
            <p style="zoom: 0.7">CRECI: {{ captador.creci }}</p>
          </div>
        </div>

        <div class="div-img-texto-corretor">
          <div class="div-corretor-icon">
            <i class="fa-sharp fa-solid fa-envelope" (click)="openEmail()"></i>
            <i class="fa-brands fa-whatsapp" (click)="openWhatsApp()"></i>
            <!-- <p>|</p>
            <i class="fa-sharp fa-solid fa-house"></i>
            <p>77</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-2" style="margin: auto !important">
    <h1 class="title-2">
      Imóveis similares<br />
      <div class="style-div"></div>
    </h1>
  </div>

  <div class="body-lista">
    <div id="carouselImoveis" class="carousel slide" data-bs-ride="false">
      <!-- Indicadores -->
      <div class="carousel-indicators">
        <button *ngFor="let group of groupedImoveisSimilares; let i = index" [attr.data-bs-target]="'#carouselImoveis'"
          [attr.data-bs-slide-to]="i" [class.active]="i === 0"></button>
      </div>

      <!-- Slides -->
      <div style="height: 65vh !important;">
        <div *ngFor="let group of groupedImoveisSimilares; let i = index" class="carousel-item"
          [class.active]="i === 0">
          <div class="cards">
            <div class="card-destaque" *ngFor="let similar of group" (click)="abreImovel(similar.slug)">
              <div class="header-card">
                <div class="div-img">
                  <img [src]="similar.imagens[0].link_thumb" alt="Imagem" class="image-card" />
                </div>
              </div>
              <div class="body-card">
                <p class="tipo">
                  <span><b>{{ similar.subtipo }}</b></span><span style="font-size: 13px">{{ similar.codigo
                    }}</span>
                </p>
                <p class="titulo titulo--sem-padding">
                  {{ similar.endereco_bairro }}
                </p>
                <div class="div-icones-geral">

                  <div class="div-icones-imovel">

                    <div *ngIf="temAreaPrivativa(similar) && similar?.subtipo | deveExibirAtributo: 'area_privativa'"
                      style="margin-right: 5px;">
                      <p>
                        <b>{{ similar.area_privativa | number:'1.0-0' }} {{similar.medida}}</b>&nbsp;
                        <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                      </p>
                    </div>

                    <p *ngIf="similar?.subtipo | deveExibirAtributo: 'terreno_total'">
                      <b>{{ (similar?.terreno_total ?? similar?.area_privativa) | number:'1.0-0' }} {{similar.medida}}
                      </b>
                      <mat-icon>border_outer</mat-icon>
                    </p>

                    <div *ngIf="similar?.dormitorios && similar?.subtipo | deveExibirAtributo: 'dormitorios'"
                      style="margin-right: 5px;">
                      <p>
                        <b>{{ similar?.dormitorios }}</b>
                        <sup *ngIf="similar?.suites && similar.suites > 0"
                          style="font-weight: 600; font-size: 0.75em;">{{
                          similar.suites }}</sup>&nbsp;
                        <i class="fa-solid fa-bed"></i>
                      </p>
                    </div>

                    <div *ngIf="similar?.subtipo | deveExibirAtributo: 'banheiros'" style="margin-right: 5px;">
                      <p>
                        <b>{{ similar.banheiros ?? 0 }}</b>&nbsp;
                        <i class="fa-solid fa-shower"></i>
                      </p>
                    </div>

                    <div *ngIf="similar?.subtipo | deveExibirAtributo: 'garagens'" style="margin: 0px 1px 0 1px;">
                      <p>
                        <b>{{ similar.garagens ?? 0 }}</b>&nbsp;
                        <i class="fa-solid fa-car"></i>
                      </p>
                    </div>

                  </div>

                  <span>
                    <span *ngIf="(similar?.valor_venda_visivel && similar?.valor_venda > 0); else verificarLocacao">
                      <p class="valor-similares">{{ similar.valor_venda | currency: 'BRL' }}</p>
                    </span>
                    <ng-template #verificarLocacao>
                      <span *ngIf="similar?.valor_locacao_visivel && similar?.valor_locacao > 0; else semValor">
                        <p class="valor-similares">{{ similar.valor_locacao | currency: 'BRL' }}/mês</p>
                      </span>
                    </ng-template>
                    <ng-template #semValor>
                      <p class="valor-similares">Valor sob consulta!</p>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Controles de navegação -->
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselImoveis" data-bs-slide="prev"
        *ngIf="!mobile">
        <div class="circle-icon">
          <svg style="margin-left: -3px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
            fill="#000" stroke="#000" stroke-width="2" class="size-1" transform="scale(-1, 1)">
            <path fill-rule="evenodd"
              d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
              clip-rule="evenodd" />
          </svg>
        </div>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselImoveis" data-bs-slide="next"
        *ngIf="!mobile">
        <div class="circle-icon">
          <svg style="margin-right: -3px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
            fill="#000" stroke="#000" stroke-width="2" class="size-1">
            <path fill-rule="evenodd"
              d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
              clip-rule="evenodd" />
          </svg>
        </div>
      </button>
    </div>
  </div>
</div>